import { Component, OnInit } from '@angular/core';

declare const cookieconsent;

@Component({
  selector: 'slotcom-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  standalone: true,
})
export class CookieConsentComponent implements OnInit {
  ngOnInit(): void {
    document.addEventListener('DOMContentLoaded', function () {
      cookieconsent.run({
        notice_banner_type: 'interstitial',
        consent_type: 'express',
        palette: 'dark',
        language: 'en',
        open_preferences_center_selector: '#cookieSettings',
      });
    });
  }
}
